module.exports = __webpack_public_path__ + "img/certificate01.0269017f.png";